import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Form, Spin, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import { notesApi, useGetNotesQuery } from '@/services/notes';
import styled, { css, StyledProp } from '@/styled';

interface NotesProps extends StyledProp {}

const Notes = ({ className }: NotesProps) => {
  const { id } = useParams();
  const { isLoading, data, refetch } = useGetNotesQuery(id);
  const [trigger, {}] = notesApi.endpoints.sendNotes.useMutation();
  const [form] = Form.useForm();

  const [newNote, setNewNote] = useState('');

  const saveNote = () => {
    trigger({ lessonId: id, text: newNote })
      .then(() => {
        refetch();
        message.success('Suas anotações salvas com sucesso!');
      })
      .catch(() => message.error('Ocorreu um erro ao salvar as suas anotações!'));
  };

  const onReset = () => {
    setNewNote(data?.text);
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }

    setNewNote(data?.text);
  }, [isLoading, data]);

  if (isLoading)
    return (
      <div className={className}>
        <Spin style={{ alignSelf: 'center' }} />
      </div>
    );

  const disableButtons = newNote === data?.text;
  return (
    <div className={className}>
      <Form
        className='formContent'
        form={form}
        initialValues={{ note: data?.text }}
        layout='vertical'
        size='large'
        autoComplete='off'
        onFinish={saveNote}
        onReset={onReset}
      >
        <Form.Item name='note'>
          <TextArea
            rows={4}
            className='notation'
            placeholder='Insira suas anotações aqui'
            onChange={evt => setNewNote(evt.target.value)}
          />
        </Form.Item>

        <Form.Item>
          <div className='formActions'>
            <Button size='large' className='profile-btnSaveChanges' htmlType='reset' disabled={disableButtons}>
              Cancelar
            </Button>
            <Button
              type='primary'
              size='large'
              className='profile-btnSaveChanges'
              htmlType='submit'
              disabled={disableButtons}
            >
              Salvar
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default styled(Notes)(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;

    textarea {
      resize: vertical;
    }

    .formContent {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    .formActions {
      gap: ${theme.space.spacing(4)};
      display: flex;
      justify-content: end;
    }

    .notesContent {
      display: flex;
      flex-direction: column;
    }

    .notation {
      cursor: default;
      :focus {
        cursor: auto;
      }
    }

    .ant-spin {
      align-self: center;
      margin: ${theme.space.pxToRem(12)};
    }
  `
);
